export const bookingPedingNoteType = {
  STUDENT_CANCELLATION: 'Student cancellation',
  STUDENT_NO_SHOW: 'Student no show',
  INCOMPLETE: 'Incomplete booking',
  NO_BOOKING_PROOF: 'No booking proof',
  AGENT_CLASH: 'Agent clash',
  CAP_REACHED: 'Cap reached',
  ZERO_COMMISSION: 'Zero commission',
  REBOOKER: 'Rebooker',
  SHORT_STAY: 'Short stay',
  MISCELLANEOUS: 'Miscellaneous',
  TENANCY_TAKEOVER: 'Tenancy takeover',
  BREAK_LEASE: 'Break lease',
  BOOKING_PROCESS: 'Booking process',
};

export const bookingPedingNote = {
  STUDENT_CANCELLATION: 'STUDENT_CANCELLATION',
  STUDENT_NO_SHOW: 'STUDENT_NO_SHOW',
  INCOMPLETE: 'INCOMPLETE',
  NO_BOOKING_PROOF: 'NO_BOOKING_PROOF',
  AGENT_CLASH: 'AGENT_CLASH',
  CAP_REACHED: 'CAP_REACHED',
  ZERO_COMMISSION: 'ZERO_COMMISSION',
  REBOOKER: 'REBOOKER',
  SHORT_STAY: 'SHORT_STAY',
  MISCELLANEOUS: 'MISCELLANEOUS',
  TENANCY_TAKEOVER: 'TENANCY_TAKEOVER',
  BREAK_LEASE: 'BREAK_LEASE',
  BOOKING_PROCESS: 'BOOKING_PROCESS',
};

export const bookingLandlordStatus = {
  READY_FOR_APPROVAL: 'READY_FOR_APPROVAL',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  APPROVED: 'APPROVED',
  READY_TO_INVOICE: 'READY_TO_INVOICE',
  PARTIAL_INVOICED: 'PARTIAL_INVOICED',
  INVOICED: 'INVOICED',
  PAID: 'PAID',
  CANCELLED: 'CANCELLED',
  NO_SHOW: 'NO_SHOW',
  UNCLAIMABLE: 'UNCLAIMABLE',
  PENDING_INVOICE: 'PENDING_INVOICE',
  PARTIALLY_PAID: 'PARTIALLY_PAID',
};

export const secondaryLandlordBookingStatus = {
  APPROVED_BREAK_LEASE: 'APPROVED_BREAK_LEASE',
  PENDING_START: 'PENDING_START',
  CASE_ASSIGNED: 'CASE_ASSIGNED',
  CASE_DONE: 'CASE_DONE',
  NO_BOOKING_PROOF: 'NO_BOOKING_PROOF',
  AGENT_CLASH: 'AGENT_CLASH',
  CAP_REACHED: 'CAP_REACHED',
  ZERO_COMMISSION: 'ZERO_COMMISSION',
  REBOOKER: 'REBOOKER',
  SHORT_STAY: 'SHORT_STAY',
  MISCELLANEOUS: 'MISCELLANEOUS',
  TENANCY_TAKEOVER: 'TENANCY_TAKEOVER',
  BOOKING_PROCESS: 'BOOKING_PROCESS',
  UNCLAIMABLE_BREAK_LEASE: 'UNCLAIMABLE_BREAK_LEASE',
  FULLY_APPROVED: 'FULLY_APPROVED',
  CASE_CLOSED: 'CASE_CLOSED',
  CREDIT_NOTE: 'CREDIT_NOTE',
};

export default bookingPedingNoteType;
